"use strict";
/* This file is generated by `pnpm bemlo bump-version` */
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
exports.version = '2025-04-23T14:48:40.498Z';
